// src/api/admin.js
function authHeaders() {
  let t = null;
  try { t = localStorage.getItem('squid.token'); } catch {}
  return t ? { 'Authorization': `Bearer ${t}` } : {};
}

export async function listUsers({ limit = 200, offset = 0 } = {}) {
  const res = await fetch(`/api/kraken-auth/admin/users?limit=${limit}&offset=${offset}`, {
    headers: { 'Accept': 'application/json', ...authHeaders() }
  });
  if (!res.ok) throw new Error(`listUsers failed: ${res.status}`);
  return res.json();
}

export async function getUser(id) {
  const res = await fetch(`/api/kraken-auth/admin/users/${encodeURIComponent(id)}`, {
    headers: { 'Accept': 'application/json', ...authHeaders() }
  });
  if (!res.ok) throw new Error(`getUser failed: ${res.status}`);
  return res.json();
}

export async function listRoles() {
  const res = await fetch(`/api/kraken-auth/admin/roles`, {
    headers: { 'Accept': 'application/json', ...authHeaders() }
  });
  if (!res.ok) throw new Error(`listRoles failed: ${res.status}`);
  return res.json();
}